import * as React from 'react';
import {RouteComponentProps} from 'react-router';
//import './Home.css';


import authService from "../services/AuthService";

import i18n from "../../../locale/i18n";
import ErrorBox from "../components/ErrorBox/ErrorBox";
import {Button, Form, Loader} from 'semantic-ui-react';
import RestClient from '../../../lib/RestClient';
import AppContainer from '../containers/AppContainer/AppContainer';
import AppFontSize from "../../../fontSize";
import {appInfo} from '../services/AppInfo';
import {AnalyticsTracking} from "../components/AnalyticsTracking/AnalyticsTracking";
let t = i18n.t.bind(i18n);

interface ProfileViewState {
  loading: boolean;
  saving: boolean;

  language: string;
  entryPoint: string;
  fontSize: string;
}

class ProfileView extends React.Component<RouteComponentProps<{}>, ProfileViewState> {

  constructor(props: RouteComponentProps<{}>) {
    super(props);
    this.state = {
      loading: false,
      saving: false,

      language: i18n.language,
      entryPoint: 'auctions',
      fontSize: 'default'
    };

  }

  componentDidMount() {
    ErrorBox.reset();
    this.setState({loading: true}, () => {
      RestClient.get('user-settings').then((data) => {
        this.setState({
          loading: false,
          language: (data.data && data.data.global && data.data.global.language) ? data.data.global.language : i18n.language,
          entryPoint: (data.data && data.data.global && data.data.global.entryPoint) ? data.data.global.entryPoint : 'auctions',
          fontSize:  (data.data && data.data.global && data.data.global.fontSize) ? data.data.global.fontSize : 'default',
        });
      }); // todo catch errors
    });
  }

  saveChanges() {
    ErrorBox.reset();
    this.setState({saving: true}, () => {
      RestClient.get('user-settings').then((response) => {
        const settings = response.data || {};
        if(!settings.global) {
          settings.global = {};
        }
        settings.global.language = this.state.language;
        settings.global.entryPoint = this.state.entryPoint;
        settings.global.fontSize = this.state.fontSize;
        RestClient.put('user-settings', settings).then(() => {
          this.setState({saving: false});
          // apply current settings to client
          i18n.changeLanguage(this.state.language);
          AppFontSize.setSize(this.state.fontSize);
          AppContainer.instance.forceUpdate();
        }).catch(() => {
          this.setState({saving: false});
        });
      }).catch(() => {
        this.setState({saving: false});
      }); // TODO proper error handling
    });
  }

  render() {
    return (
        <>
          <AnalyticsTracking page="profile" />
          <h1>{t('Profile.Profile')}</h1>
          <p>{t('Profile.LoggedInAs%s', {name: authService.principal.name})}</p>
          <p><strong>{t('Profile.Email')}:</strong> {authService.principal.mail}</p>
          {appInfo.authenticationMethod === 'openid_connect' && appInfo.idProviderRealmUrl && (
              <a href={appInfo.idProviderRealmUrl + '/account/password'}>{t('Profile.ChangePassword')}</a>
          )}
          {appInfo.authenticationMethod === 'native' && (
              <a href="/" onClick={() => false}>{t('Profile.ChangePassword')}</a>
          )}
          <h2>{t('Profile.Settings')}</h2>
          {this.state.loading ? (
              <Loader active={true} />
          ) : (
            <Form>
              <Form.Select fluid label={t('Profile.Language')} options={[
                {key: 'de', text: t('Languages.de'), value: 'de'},
                {key: 'nl', text: t('Languages.nl'), value: 'nl'},
                {key: 'en', text: t('Languages.en'), value: 'en'}
              ]} value={this.state.language} onChange={(ev, data) => this.setState({language: data.value as string})} />
              <Form.Select fluid label={t('Profile.EntryPoint')} options={[
                {key: 'auctions', text: t('Route.Auctions'), value: 'auctions'},
                {key: 'logistics', text: t('Route.Inventory'), value: 'logistics'},
                {key: 'downloads', text: t('Route.Files'), value: 'downloads'}
              ]} value={this.state.entryPoint} onChange={(ev, data) => this.setState({entryPoint: data.value as string})} />
              <Form.Select fluid label={t('Profile.FontSize')} options={[
                {key: 'small', text: t('Profile.FontSizeSmall'), value: 'small'},
                {key: 'default', text: t('Profile.FontSizeDefault'), value: 'default'},
                {key: 'large', text: t('Profile.FontSizeLarge'), value: 'large'}
              ]} value={this.state.fontSize} onChange={(ev, data) => this.setState({fontSize: data.value as string})} />
              <Button type="button" primary={true} onClick={() => this.saveChanges()}>
                {this.state.saving ? (
                    <><Loader inline={true} active={true} size="tiny" inverted={true} /> {t('Common.Save')}</>
                ) : t('Common.Save')}
              </Button>
            </Form>
          )}

        </>
    );

  }
}

export default ProfileView;